export default function HeroSection() {
  return (
    <section id="hero" className="relative pt-20 md:pt-[88px] min-h-[600px] md:min-h-[680px] flex items-center bg-background-50 overflow-hidden">
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-0 right-0 w-[500px] md:w-[700px] h-full bg-primary-50/60 rounded-bl-[120px]" />
      </div>

      <div className="relative z-10 w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-center gap-8 md:gap-12 py-10 md:py-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-accent-100 text-accent-700 text-xs font-medium mb-5 whitespace-nowrap">
              <i className="ri-fire-line text-sm"></i>
              <span>吃瓜爆料网最新地址已更新</span>
            </div>

            <h1 className="font-heading text-3xl sm:text-4xl md:text-5xl lg:text-[56px] leading-tight text-foreground-950 mb-4">
              吃瓜爆料网
              <span className="block text-primary-500 text-2xl sm:text-3xl md:text-4xl lg:text-[42px] mt-1">
                一手爆料 · 实时追踪
              </span>
            </h1>

            <p className="text-sm md:text-base text-foreground-600 leading-relaxed max-w-xl mx-auto lg:mx-0 mb-2">
              吃瓜爆料网官方发布页，一站式解决你找地址、下App、追热点的所有需求。无论你是想看反差视频、蹲塌房现场，还是追最新的黑料爆料，这里都是你收藏夹里最该保留的入口。
            </p>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed max-w-xl mx-auto lg:mx-0 mb-6">
              本站每日同步吃瓜爆料网站核心资源，确保你第一时间触达一手内容，杜绝失效地址的烦恼。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-4 md:gap-6 mb-7">
              <div className="flex items-center gap-2 text-sm text-foreground-500">
                <span className="w-2 h-2 rounded-full bg-green-500"></span>
                <span>每日更新</span>
              </div>
              <div className="flex items-center gap-2 text-sm text-foreground-500">
                <span className="w-2 h-2 rounded-full bg-accent-500"></span>
                <span>全网热点追踪</span>
              </div>
              <div className="flex items-center gap-2 text-sm text-foreground-500">
                <span className="w-2 h-2 rounded-full bg-primary-500"></span>
                <span>地址永不失效</span>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center gap-3 justify-center lg:justify-start">
              <a
                href="#app"
                className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-background-50 font-semibold rounded-lg hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer no-underline text-sm"
              >
                <i className="ri-download-2-line text-lg"></i>
                下载吃瓜爆料网App
              </a>
              <a
                href="#cards"
                className="inline-flex items-center gap-2 px-6 py-3 border-2 border-foreground-200 text-foreground-700 font-semibold rounded-lg hover:border-primary-400 hover:text-primary-500 transition-colors whitespace-nowrap cursor-pointer no-underline text-sm"
              >
                <i className="ri-arrow-right-line text-lg"></i>
                浏览热门爆料
              </a>
            </div>
          </div>

          <div className="flex-1 w-full flex justify-center lg:justify-end">
            <div className="relative w-full max-w-[480px] aspect-[4/3] rounded-2xl overflow-hidden bg-background-200">
              <img
                src="https://readdy.ai/api/search-image?query=Dramatic%20entertainment%20news%20studio%20scene%20with%20vibrant%20warm%20orange%20and%20coral%20lighting%20on%20dark%20background%2C%20breaking%20news%20atmosphere%2C%20glowing%20spotlight%20effect%2C%20bold%20dynamic%20composition%2C%20modern%20media%20production%20aesthetic%2C%20energetic%20and%20eye-catching%20visual%20with%20dramatic%20shadows%2C%20hot%20news%20concept%20photography%2C%20sleek%20tech%20elements%20with%20warm%20accents&width=960&height=720&seq=hero-visual-chigua&orientation=landscape"
                alt="吃瓜爆料网 - 一手娱乐爆料平台"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-tr from-black/20 via-transparent to-transparent" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}